/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-ignore
import bootstrap from './bootstrap';
bootstrap(function () { });
